import { useRef } from 'react';

import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import CopyButton from '#client/components/CopyButton';

import Field from './Field';
import { IconButton } from './VGS.styles';

export default function TextField({ title, value, loading, clickCopyTracker }) {
  const copyButtonRef = useRef();
  const copyButton = (
    <CopyButton
      arrow
      callback={clickCopyTracker}
      copyText={value}
      placement="top"
      ref={copyButtonRef}
    >
      <IconButton
        label=""
        onClick={copyButtonRef?.current?.copyAndShowTooltip}
      />
    </CopyButton>
  );
  return (
    <Field
      copyButton={copyButton}
      loading={loading}
      title={title}
      valueNode={
        <Text
          color="secondary"
          size="xl"
        >
          {value}
        </Text>
      }
    />
  );
}

TextField.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  clickCopyTracker: PropTypes.func
};
